import script from "./FixtureBookMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureBookMarket.vue?vue&type=script&setup=true&lang=js"

import "./FixtureBookMarket.vue?vue&type=style&index=0&id=ccc0e518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccc0e518"]])

export default __exports__